'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _contacts = require('redux/modules/contacts');

var _email = require('redux/modules/email');

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _components = require('components');

var _Contactos = require('./Contactos.scss');

var _Contactos2 = _interopRequireDefault(_Contactos);

var _reactRouter = require('react-router');

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Contactos = (_dec = (0, _reduxConnect.asyncConnect)([{
    key: 'contacts',
    promise: function promise(_ref) {
        var _ref$store = _ref.store,
            dispatch = _ref$store.dispatch,
            getState = _ref$store.getState;

        var state = getState();
        if (!state.contacts) {
            return dispatch((0, _contacts.getContacts)());
        }
        return null;
    }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
    return { list: state.contacts.list };
}, { getContacts: _contacts.getContacts, sendEmail: _email.sendEmail }), _dec(_class = _dec2(_class = function (_React$Component) {
    (0, _inherits3.default)(Contactos, _React$Component);

    function Contactos(props) {
        (0, _classCallCheck3.default)(this, Contactos);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Contactos.__proto__ || (0, _getPrototypeOf2.default)(Contactos)).call(this, props));

        _this.state = {
            contactsList: [],
            contactsIsEmpty: undefined,
            main_identifier: 'email',
            start: 0,
            limit: 100
        };
        return _this;
    }

    (0, _createClass3.default)(Contactos, [{
        key: 'componentDidMount',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var response, contactsList;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.props.getContacts({
                                    main_identifier: this.state.main_identifier,
                                    start: this.state.start,
                                    limit: this.state.limit
                                });

                            case 2:
                                response = _context.sent;
                                contactsList = response.filter(function (contact) {
                                    return contact.email && contact.profile.first_name;
                                });


                                if (contactsList.length == 0) {
                                    this.setState({ contactsIsEmpty: true });
                                } else {
                                    this.setState({ contactsList: contactsList, contactsIsEmpty: false });
                                }

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentDidMount() {
                return _ref2.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'changeStartAndLimit',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                var newStart, response, contactsList, concatData;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                newStart = this.state.start + 100;
                                _context2.next = 3;
                                return this.props.getContacts({
                                    main_identifier: this.state.main_identifier,
                                    start: newStart,
                                    limit: this.state.limit
                                });

                            case 3:
                                response = _context2.sent;
                                contactsList = response.filter(function (contact) {
                                    return contact.email && contact.profile.first_name;
                                });
                                concatData = this.state.contactsList.concat(contactsList);

                                if (contactsList.length == 0) {
                                    console.log('no hay mas data por cargar');
                                } else {
                                    this.setState({
                                        contactsList: concatData,
                                        contactsIsEmpty: false,
                                        start: newStart
                                    });
                                }

                            case 7:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function changeStartAndLimit() {
                return _ref3.apply(this, arguments);
            }

            return changeStartAndLimit;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var contactsList = this.state.contactsList;
            var layoutData = this.props.data;
            {
                if (this.state.contactsIsEmpty != undefined) {
                    if (this.state.contactsIsEmpty) {
                        return _react2.default.createElement(
                            'div',
                            { className: _Contactos2.default.noContacts },
                            _react2.default.createElement(
                                'div',
                                { className: _Contactos2.default.content },
                                _react2.default.createElement(
                                    'h1',
                                    null,
                                    (0, _translations2.default)('NO CONTACTS WITH EMAIL ADD TO CONTINUE')
                                ),
                                _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/contacts/add' },
                                    _react2.default.createElement(
                                        'button',
                                        { className: _Contactos2.default.createContact },
                                        (0, _translations2.default)('CREATE CONTACT')
                                    )
                                )
                            )
                        );
                    } else {
                        return contactsList.length ? _react2.default.createElement(
                            'div',
                            { className: _Contactos2.default.mainContainer },
                            _react2.default.createElement(ContactsTab, (0, _extends3.default)({
                                contactsList: this.state.contactsList
                            }, layoutData, {
                                email: this.props.sendEmail,
                                completeComponentFunction: this.props.completeComponentFunction,
                                dataBetweenComponents: this.props.dataBetweenComponents,
                                changeStartAndLimit: function changeStartAndLimit() {
                                    return _this2.changeStartAndLimit();
                                }
                            }))
                        ) : _react2.default.createElement(_components.Loading, null);
                    }
                } else {
                    return _react2.default.createElement(
                        'div',
                        { className: _Contactos2.default.loading },
                        _react2.default.createElement(
                            'div',
                            { className: _Contactos2.default.logo },
                            _react2.default.createElement(_components.Loading, null)
                        )
                    );
                }
            }
        }
    }]);
    return Contactos;
}(_react2.default.Component)) || _class) || _class);
exports.default = Contactos;

var ContactsTab = function (_React$Component2) {
    (0, _inherits3.default)(ContactsTab, _React$Component2);

    function ContactsTab(props) {
        (0, _classCallCheck3.default)(this, ContactsTab);

        var _this3 = (0, _possibleConstructorReturn3.default)(this, (ContactsTab.__proto__ || (0, _getPrototypeOf2.default)(ContactsTab)).call(this, props));

        _this3.returnInput = function (original, index, contactSelected) {
            var _React$createElement;

            return _react2.default.createElement('input', (_React$createElement = {
                type: 'checkbox',
                className: 'checkbox'
            }, (0, _defineProperty3.default)(_React$createElement, 'className', _Contactos2.default.checkBox), (0, _defineProperty3.default)(_React$createElement, 'key', index), (0, _defineProperty3.default)(_React$createElement, 'defaultChecked', _this3.isSelected(original, _this3.state.contactSelected)), (0, _defineProperty3.default)(_React$createElement, 'onChange', function onChange() {
                return _this3.toggleRow(original, index, contactSelected);
            }), _React$createElement));
        };

        _this3.handleRenderTab = function () {
            var selectedTab = void 0,
                data = void 0;
            var email = data;
            var columns = [{
                Header: 'Nombre',
                accessor: 'profile.first_name.value'
            }, {
                Header: 'Apellido',
                accessor: 'profile.last_name.value'
            }, {
                Header: 'Correo',
                accessor: 'profile.email.value'
            }, {
                id: "checkbox",
                accessor: "",
                Cell: function Cell(_ref4) {
                    var original = _ref4.original,
                        index = _ref4.index;

                    return _this3.returnInput(original, index, _this3.state.contactSelected);
                },
                Header: 'Seleccionar',
                sortable: false
            }];

            selectedTab = _this3.state.newData.length > 0 ? _react2.default.createElement(
                'div',
                { className: _Contactos2.default.prueba },
                _react2.default.createElement(
                    'div',
                    { className: _Contactos2.default.table },
                    _react2.default.createElement(_reactTable2.default, {
                        columns: columns,
                        data: _this3.state.newData,
                        defaultPageSize: 8,
                        pageSizeOptions: [5, 8],
                        onFetchData: function onFetchData(state) {
                            return _this3.fetchData(state);
                        }
                    })
                )
            ) : _react2.default.createElement(_components.Loading, null);
            return selectedTab;
        };

        _this3.renderChips = function (contacts) {
            var chips = [];
            var name = void 0,
                lastName = void 0;
            contacts.map(function (contact) {
                name = contact.profile.first_name ? contact.profile.first_name.value : '';
                lastName = contact.profile.last_name ? contact.profile.last_name.value : '';
                chips.push(_react2.default.createElement(
                    'div',
                    { className: _Contactos2.default.chip },
                    _react2.default.createElement(
                        'div',
                        { className: _Contactos2.default.chipContent },
                        '' + (name + ' ' + lastName)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Contactos2.default.chipClose, onClick: function onClick() {
                                return _this3.toggleRow(contact, undefined, _this3.state.contactSelected);
                            } },
                        _react2.default.createElement(
                            'svg',
                            { className: _Contactos2.default.chipSvg, focusable: 'false',
                                viewBox: '0 0 24 24', 'aria-hidden': 'true' },
                            _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12  10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
                        )
                    )
                ));
            });
            _this3.setState({ chips: chips });
        };

        _this3.toggleRow = function (selected, indexParam, contactSelectedState) {
            var contactSelected = contactSelectedState;
            var flag = true;
            var index = contactSelected.findIndex(function (contact) {
                return contact.id === selected.id;
            });

            index == -1 ? contactSelected.push(selected) : contactSelected.splice(index, 1);

            _this3.setState({ contactSelected: contactSelected }, function () {
                _this3.renderChips(contactSelected);
                _this3.handleRenderTab();
                if (contactSelected.length >= 1) {
                    _this3.props.completeComponentFunction(flag);
                    _this3.props.dataBetweenComponents(_this3.state);
                }
            });
        };

        _this3.isSelected = function (original, contactSelected) {
            var index = contactSelected.findIndex(function (contact) {
                return contact.id === original.id;
            });
            return index == -1 ? false : true;
        };

        _this3.state = {
            selectedTab: null,
            contactSelected: [],
            chips: [],
            selected: {},
            selectAll: 0,
            template_uid: _this3.props.template_uid,
            account: _this3.props.account,
            isChecked: false,
            page: 0,
            pageCount: 12,
            defaultPageSize: 8,
            newData: []
        };
        return _this3;
    }

    (0, _createClass3.default)(ContactsTab, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({ newData: this.props.contactsList });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.contactsList.length > this.props.contactsList.length) {
                this.setState({ newData: nextProps.contactsList });
            }
        }
    }, {
        key: 'fetchData',
        value: function fetchData(state) {
            if (state.page > 0) {
                if (state.pages == state.page + 1) {
                    this.props.changeStartAndLimit();
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _Contactos2.default.tabContainer },
                _react2.default.createElement(
                    'div',
                    { className: _Contactos2.default.chipContainer },
                    _react2.default.createElement(
                        'span',
                        { className: _Contactos2.default.span },
                        this.state.contactSelected.length > 0 ? _react2.default.createElement(
                            'span',
                            { style: { marginTop: '10px' } },
                            'Enviando a:'
                        ) : _react2.default.createElement(
                            'h3',
                            null,
                            'SELECCIONA CONTACTO DESTINO'
                        ),
                        this.state.chips
                    )
                ),
                this.handleRenderTab()
            );
        }
    }]);
    return ContactsTab;
}(_react2.default.Component);

module.exports = exports['default'];